export const selangor = [
  '7500',
  '47507',
  '47600',

  '46000',
  '46050',
  '46100',
  '46150',
  '46200',
  '46300',
  '46350',
  '46400',
  '46506',
  '46547',
  '46549',
  '46551',
  '46564',
  '46582',
  '46598',
  '46662',
  '46667',
  '46668',
  '46672',
  '46700',
  '46710',
  '46720',
  '46730',
  '46740',
  '46750',
  '46760',
  '46770',
  '46780',
  '46781',
  '46782',
  '46783',
  '46784',
  '46785',
  '46786',
  '46787',
  '46788',
  '46789',
  '46790',
  '46791',
  '46792',
  '46793',
  '46794',
  '46795',
  '46796',
  '46797',
  '46798',
  '46799',
  '46800',
  '46801',
  '46802',
  '46803',
  '46804',
  '46805',
  '46806',
  '46860',
  '46870',
  '46960',
  '46962',
  '46966',
  '46968',
  '46970',
  '46972',
  '46974',
  '46976',
  '46978',
  '47300',
  '47301',
  '47307',
  '47308',
  '47400',
  '47410',
  '47500',
  '47800',
  '47810',
  '47820',
  '47830',

  '47300',
  '47301',
  '47310',
  '47610',
  '47620',
  '47630',
  '47640',
  '47650'
]

export const kualaLumpur = [
  '50000',
  '50050',
  '50088',
  '50100',
  '50150',
  '50200',
  '50250',
  '50300',
  '50350',
  '50400',
  '50450',
  '50460',
  '50470',
  '50480',
  '50490',
  '50500',
  '50502',
  '50504',
  '50505',
  '50506',
  '50507',
  '50508',
  '50512',
  '50514',
  '50515',
  '50519',
  '50528',
  '50529',
  '50530',
  '50532',
  '50534',
  '50536',
  '50540',
  '50544',
  '50546',
  '50548',
  '50550',
  '50551',
  '50552',
  '50554',
  '50556',
  '50560',
  '50562',
  '50564',
  '50566',
  '50568',
  '50572',
  '50576',
  '50578',
  '50580',
  '50582',
  '50586',
  '50588',
  '50590',
  '50592',
  '50594',
  '50596',
  '50598',
  '50599',
  '50600',
  '50603',
  '50604',
  '50605',
  '50608',
  '50609',
  '50610',
  '50612',
  '50614',
  '50620',
  '50621',
  '50622',
  '50623',
  '50626',
  '50632',
  '50634',
  '50636',
  '50638',
  '50640',
  '50642',
  '50644',
  '50646',
  '50648',
  '50650',
  '50652',
  '50653',
  '50656',
  '50658',
  '50660',
  '50661',
  '50662',
  '50664',
  '50666',
  '50668',
  '50670',
  '50672',
  '50673',
  '50676',
  '50677',
  '50678',
  '50680',
  '50682',
  '50684',
  '50688',
  '50694',
  '50700',
  '50702',
  '50704',
  '50706',
  '50708',
  '50710',
  '50712',
  '50714',
  '50716',
  '50718',
  '50720',
  '50722',
  '50724',
  '50726',
  '50728',
  '50730',
  '50732',
  '50734',
  '50736',
  '50738',
  '50740',
  '50742',
  '50744',
  '50746',
  '50748',
  '50750',
  '50752',
  '50754',
  '50758',
  '50760',
  '50762',
  '50764',
  '50766',
  '50768',
  '50770',
  '50772',
  '50774',
  '50776',
  '50778',
  '50780',
  '50782',
  '50784',
  '50786',
  '50788',
  '50790',
  '50792',
  '50794',
  '50796',
  '50798',
  '50800',
  '50802',
  '50804',
  '50806',
  '50808',
  '50810',
  '50812',
  '50814',
  '50816',
  '50818',
  '50901',
  '50902',
  '50903',
  '50904',
  '50906',
  '50907',
  '50908',
  '50909',
  '50910',
  '50911',
  '50912',
  '50913',
  '50914',
  '50915',
  '50916',
  '50917',
  '50918',
  '50919',
  '50920',
  '50921',
  '50922',
  '50923',
  '50924',
  '50925',
  '50926',
  '50927',
  '50928',
  '50929',
  '50930',
  '50931',
  '50932',
  '50933',
  '50934',
  '50935',
  '50936',
  '50937',
  '50938',
  '50939',
  '50940',
  '50941',
  '50942',
  '50943',
  '50944',
  '50945',
  '50946',
  '50947',
  '50948',
  '50949',
  '50950',
  '50988',
  '50989',
  '50990',
  '51000',
  '51100',
  '51200',
  '51700',
  '51990',
  '52000',
  '52100',
  '52200',
  '53000',
  '53100',
  '53200',
  '53300',
  '53700',
  '53800',
  '53990',
  '54000',
  '54100',
  '54200',
  '55000',
  '55100',
  '55200',
  '55300',
  '55700',
  '55710',
  '55720',
  '55900',
  '55902',
  '55904',
  '55906',
  '55908',
  '55910',
  '55912',
  '55914',
  '55916',
  '55918',
  '55920',
  '55922',
  '55924',
  '55926',
  '55928',
  '55930',
  '55932',
  '55934',
  '55990',
  '56000',
  '56100',
  '57000',
  '57100',
  '57700',
  '57990',
  '58000',
  '58100',
  '58200',
  '58700',
  '58990',
  '59000',
  '59100',
  '59200',
  '59700',
  '59800',
  '59990'
]

export default [...selangor, ...kualaLumpur]
